/**
 * Toggles the collapsed/expanded state of an accordion element
 * @param {Event} event - Click event triggering the toggle
 * @param {HTMLElement|HTMLElement[]} element - Accordion element or array of elements (uses first element if array)
 * @returns {void}
 * @description Handles the animation and styling of accordion expand/collapse,
 * including caret icon rotation and height transitions
 */

export default function toggleAccordion(event, element) {
    element = Array.isArray(element) ? element[0] : element;
    const caret = event.target.querySelector('.caret');

    if (!element.classList.contains('accordion')) {
        return;
    }

    const isCollapsed = element.classList.contains('collapsed');

    if (isCollapsed) {
        expandAccordion(element, caret);
    } else {
        collapseAccordion(element, caret);
    }
}

function expandAccordion(element, caret) {
    element.classList.remove('collapsed');
    element.style.height = '0';

    setTimeout(() => {
        caret.classList.remove('rotate-90');
        element.style.height = `${element.scrollHeight}px`;
        element.style.visibility = 'visible';
    }, 50);
}

function collapseAccordion(element, caret) {
    element.style.height = `${element.scrollHeight}px`;

    setTimeout(() => {
        element.style.height = '0';
        element.classList.add('collapsed');
        caret.classList.add('rotate-90');
    }, 50);
}
